import React from 'react'
import Navbar from '../components/sections/Navbar'
import HeroSection from '../components/sections/HeroSection'
import OfferingSection from '../components/sections/OfferingSection'
import VisionSection from '../components/sections/VisionSection'
import CtaSection from '../components/sections/CtaSection'
import Footer from '../components/sections/Footer'
import { useScrollAnimation } from '../hooks/useScrollAnimation'
import { useSEO } from '../hooks/useSEO'

// ─── JSON-LD: Organization schema ────────────────────────────────────────────
const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'AugmentAppz',
  url: 'https://augmentappz.ai/',
  logo: 'https://augmentappz.ai/logo.png',
  description:
    'AugmentAppz enables businesses to transition from traditional software environments to AI-native organizations capable of building intelligent applications and autonomous systems at scale.',
  foundingLocation: {
    '@type': 'Place',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Bengaluru',
      addressRegion: 'Karnataka',
      addressCountry: 'IN',
    },
  },
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'innovate@augmentappz.ai',
    contactType: 'customer support',
    availableLanguage: 'English',
  },
  founder: {
    '@type': 'Person',
    name: 'Balavigneshwaran M',
    jobTitle: 'Founder & CEO',
    sameAs: [
      'https://www.linkedin.com/in/balavigneshwaran-manogaran',
      'https://x.com/AugmentWithBala',
    ],
  },
  sameAs: [
    'https://www.linkedin.com/company/augmentappz',
    'https://x.com/AugmentWithBala',
  ],
}

/**
 * Home — the main landing page.
 * Composes all sections in order.
 */
export default function Home() {
  useSEO({
    title: 'AugmentAppz — AI-Native Enterprise Infrastructure',
    description:
      'AugmentAppz enables businesses to transition from traditional software environments to AI-native organizations capable of building intelligent applications and autonomous systems at scale.',
    keywords:
      'enterprise AI, AI-native platform, AI transformation, intelligent agents, agentic AI, AI infrastructure, Bengaluru AI company, AugmentAppz, production AI',
    canonical: 'https://augmentappz.ai/',
    jsonLd: orgSchema,
  })

  useScrollAnimation()

  return (
    <>
      <Navbar />
      <main aria-label="Home page">
        <HeroSection />
        <OfferingSection />
        <VisionSection />
        <CtaSection />
      </main>
      <Footer />
    </>
  )
}
